/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { isLocalRuntime } from '@/utils/runtime'

import pkg from '../../../package.json'

export class Logger {
  #transport = console

  #baseFormat = `font-weight:bold;padding:6px;border:solid 1px white;border-radius:3px;`

  #log(method, hex, ...args) {
    const callable = this.#transport[method]

    callable(
      `%c${pkg.name}`,
      `${this.#baseFormat}background:${hex}`,
      '\n\n',
      ...args,
    )
  }

  info(...args) {
    if (!isLocalRuntime) return

    this.#log('info', '#326fab', ...args)
  }

  success(...args) {
    if (!isLocalRuntime) return

    this.#log('info', '#8ac24a', ...args)
  }

  warn(...args) {
    if (!isLocalRuntime) return

    this.#log('info', '#ffb143', ...args)
  }

  error(...args) {
    if (!isLocalRuntime) return

    this.#log('error', '#e61e50', ...args)
  }
}
